<apx-chart [chart]="chartOptions.chart" [colors]="chartOptions.colors" [labels]="chartOptions.labels"
           [responsive]="chartOptions.responsive" [series]="chartOptions.series"
           [title]="chartOptions.title"></apx-chart>
